// навешивем z-индексы в порядке убывания, для плавного ховера
document.querySelectorAll('[data-product-list]').forEach((list) => {
  const cards = list.querySelectorAll('[data-product-card]');
  cards.forEach((card, index) => {
    card.style.zIndex = cards.length - index;
  })
});